/** System-managed hourly GTM sequence automation (Every hour → Advance GTM sequence). */

function asPlain(rule: any): any {
  if (rule && typeof rule.toJS === "function") return rule.toJS();
  return rule || {};
}

export function isGtmHourlySequenceRule(rule: any): boolean {
  const plain = asPlain(rule);
  if (!plain) return false;
  if (plain.app === "gtm") return true;

  const events = plain.events || (plain.startEvent ? [plain.startEvent] : []);
  const start = events[0] || plain.startEvent || {};
  const startData = start.data || {};
  const scheduled =
    start.value === "SCHEDULED" ||
    startData.type === "SCHEDULED" ||
    startData.operator === "SCHEDULED" ||
    startData.inputType === "SCHEDULED";
  if (!scheduled) return false;

  const actions = plain.actions || [];
  return actions.some(
    (action: any) => (action?.data?.operator || "") === "ADVANCE_GTM_SEQUENCE"
  );
}
